export default function CheckBoxLoader() {
    return (
        <>
            <span className="flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-sky-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-10 bg-sky-500"></span>
            </span>
        </>
    );
}

